module.exports = __webpack_public_path__ + "static/media/Team.f132162b.jpg";